import React from "react";
import styled from "styled-components";
import { types, Repeater } from "react-bricks/frontend";
import { color } from "styles/colours";
import { mobile } from "components/templates/Breakpoints";
import {
  getVerticalPadding,
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import { backgroundColorProp } from "../utils/backgroundColor";

export interface TextWithChecklistItemProps {
  reverse: boolean;
  paddingVertical?: VerticalPadding;
  backgroundColor: types.IColor;
}

export const TextWithChecklist: types.Brick<TextWithChecklistItemProps> = ({
  reverse = false,
  paddingVertical,
  backgroundColor,
}) => {
  return (
    <VerticalPaddingWrapper
      paddingVertical={paddingVertical}
      backgroundColor={backgroundColor?.color}
    >
      <Container reverse={reverse}>
        <TextContainer>
          <Repeater propName="copyBlock" />
        </TextContainer>

        <Repeater
          propName="checklistItems"
          renderWrapper={(items) => <ListContainer>{items}</ListContainer>}
        />
      </Container>
    </VerticalPaddingWrapper>
  );
};

TextWithChecklist.schema = {
  name: "text-with-checklist",
  label: "Text With Checklist",
  previewImageUrl: "/static/bricks/text-with-list.png",
  getDefaultProps: () => ({
    verticalPadding: "s",
    backgroundColor: { color: color.white },
  }),
  repeaterItems: [
    {
      name: "copyBlock",
      itemType: "text-with-heading-block",
      itemLabel: "Copy",
      min: 1,
      max: 1,
    },
    {
      name: "checklistItems",
      itemType: "checklist-item",
      itemLabel: "Checklist Item",
      min: 1,
      max: 8,
    },
  ],
  sideEditProps: [
    {
      name: "reverse",
      label: "Reverse layout",
      type: types.SideEditPropType.Boolean,
      shouldRefreshStyles: true,
    },
    backgroundColorProp,
    verticalPadSideProp,
  ],
};

const ZIG_ZAG_BREAKPOINT = `@media only screen and (max-width: 76rem)`;

const Container = styled.div<{ reverse: boolean }>`
  display: flex;
  justify-content: center;
  gap: 8em;
  flex-direction: ${(p) => (p.reverse ? "row-reverse" : "row")};

  ${ZIG_ZAG_BREAKPOINT} {
    flex-direction: column;
    gap: 3rem;
    align-items: center;

    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

const TextContainer = styled.div`
  width: 30rem;
  display: flex;
  align-items: center;
  text-align: right;

  p,
  h2 {
    text-align: right;
  }

  ${ZIG_ZAG_BREAKPOINT} {
    text-align: left;
    width: 34rem;
    p,
    h2 {
      text-align: left;
    }
  }

  ${mobile} {
    width: 100%;
  }
`;

const ListContainer = styled.div`
  width: 34rem;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media only screen and (max-width: 36rem) {
    width: 100%;
  }
`;
